// 직원 계정 관리 (doc_agency owner 전용)
// 사용처: Settings 페이지의 "직원 관리" 탭
import React, { useEffect, useState } from 'react';
import { API, authFetch } from '../utils/api';

export default function MemberManage(props) {
  var companyId = props.companyId;
  var showToast = props.showToast;
  var _ml = useState([]); var members = _ml[0]; var setMembers = _ml[1];
  var _ld = useState(false); var loading = _ld[0]; var setLoading = _ld[1];
  var _sh = useState(false); var showForm = _sh[0]; var setShowForm = _sh[1];
  var _f = useState({ userId: '', password: '', name: '' }); var form = _f[0]; var setForm = _f[1];
  var _su = useState(false); var submitting = _su[0]; var setSubmitting = _su[1];

  var load = function() {
    if (!companyId) return;
    setLoading(true);
    authFetch(API + '/auth/members?companyId=' + companyId)
      .then(function(r) { return r.json(); })
      .then(function(d) { setMembers((d && d.members) || []); })
      .catch(function() {})
      .finally(function() { setLoading(false); });
  };

  useEffect(function() { load(); }, [companyId]);

  var handleCreate = function() {
    if (!form.userId || form.userId.length < 3) { showToast && showToast('\uC544\uC774\uB514\uB294 3\uC790 \uC774\uC0C1', 'err'); return; }
    if (!form.password || form.password.length < 4) { showToast && showToast('\uBE44\uBC00\uBC88\uD638\uB294 4\uC790 \uC774\uC0C1', 'err'); return; }
    if (!form.name) { showToast && showToast('\uC774\uB984 \uD544\uC694', 'err'); return; }
    setSubmitting(true);
    authFetch(API + '/auth/create-member', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: form.userId.trim(), password: form.password, name: form.name.trim(), companyId: companyId }),
    })
      .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
      .then(function(res) {
        if (!res.ok) { showToast && showToast(res.data.error || '\uC0DD\uC131 \uC2E4\uD328', 'err'); return; }
        showToast && showToast('\uC9C1\uC6D0 \uACC4\uC815 \uC0DD\uC131 \uC644\uB8CC', 'ok');
        setForm({ userId: '', password: '', name: '' });
        setShowForm(false);
        load();
      })
      .catch(function() { showToast && showToast('\uC11C\uBC84 \uC624\uB958', 'err'); })
      .finally(function() { setSubmitting(false); });
  };

  var handleDelete = function(m) {
    if (!window.confirm('\"' + m.name + '\" \uACC4\uC815\uC744 \uC774 \uC5C5\uCCB4\uC5D0\uC11C \uC81C\uAC70\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?')) return;
    authFetch(API + '/auth/members/' + m.id + '?companyId=' + companyId, { method: 'DELETE' })
      .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
      .then(function(res) {
        if (!res.ok) { showToast && showToast(res.data.error || '\uC0AD\uC81C \uC2E4\uD328', 'err'); return; }
        showToast && showToast('\uC81C\uAC70 \uC644\uB8CC', 'ok');
        load();
      })
      .catch(function() { showToast && showToast('\uC11C\uBC84 \uC624\uB958', 'err'); });
  };

  var cellStyle = { padding: '10px 12px', borderBottom: '1px solid #eef2f7', fontSize: 13 };
  var inputStyle = { width: '100%', padding: '8px 10px', border: '1px solid #d0d5dd', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };

  return (
    <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #eee', padding: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#222' }}>{'\uC9C1\uC6D0 \uACC4\uC815 \uAD00\uB9AC'}</div>
        {!showForm && (
          <button onClick={function() { setShowForm(true); }} style={{ padding: '8px 14px', borderRadius: 6, background: '#1B3A5C', color: '#fff', fontWeight: 700, fontSize: 13, border: 'none', cursor: 'pointer' }}>
            {'+ \uC9C1\uC6D0 \uCD94\uAC00'}
          </button>
        )}
      </div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 14, lineHeight: 1.6 }}>
        {'\uBCF8 \uC5C5\uCCB4\uC758 owner\u2014\uC9C1\uC6D0 \uACC4\uC815\uC744 \uC9C1\uC811 \uC0DD\uC131/\uC0AD\uC81C\uD569\uB2C8\uB2E4. \uC9C1\uC6D0\uC740 \uB3D9\uC77C\uD55C \uC5C5\uCCB4 \uB370\uC774\uD130\uC5D0 \uC811\uADFC \uAC00\uB2A5\uD558\uBA70, owner\uB9CC \uC124\uC815/\uC9C1\uC6D0 \uAD00\uB9AC\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.'}
      </div>

      {showForm && (
        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: 14, marginBottom: 14 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
            <div><label style={{ fontSize: 11, fontWeight: 600, color: '#64748b', display: 'block', marginBottom: 4 }}>{'\uC544\uC774\uB514'}</label>
              <input style={inputStyle} value={form.userId} onChange={function(e) { setForm(Object.assign({}, form, { userId: e.target.value })); }} /></div>
            <div><label style={{ fontSize: 11, fontWeight: 600, color: '#64748b', display: 'block', marginBottom: 4 }}>{'\uBE44\uBC00\uBC88\uD638'}</label>
              <input type="password" style={inputStyle} value={form.password} onChange={function(e) { setForm(Object.assign({}, form, { password: e.target.value })); }} /></div>
            <div><label style={{ fontSize: 11, fontWeight: 600, color: '#64748b', display: 'block', marginBottom: 4 }}>{'\uC774\uB984'}</label>
              <input style={inputStyle} value={form.name} onChange={function(e) { setForm(Object.assign({}, form, { name: e.target.value })); }} /></div>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 10, justifyContent: 'flex-end' }}>
            <button onClick={function() { setShowForm(false); setForm({ userId: '', password: '', name: '' }); }} style={{ padding: '7px 14px', borderRadius: 6, background: '#fff', color: '#475569', fontWeight: 600, fontSize: 12, border: '1px solid #d0d5dd', cursor: 'pointer' }}>{'\uCDE8\uC18C'}</button>
            <button disabled={submitting} onClick={handleCreate} style={{ padding: '7px 14px', borderRadius: 6, background: '#1B3A5C', color: '#fff', fontWeight: 700, fontSize: 12, border: 'none', cursor: submitting ? 'default' : 'pointer', opacity: submitting ? 0.6 : 1 }}>
              {submitting ? '\uCC98\uB9AC\uC911...' : '\uC0DD\uC131'}
            </button>
          </div>
        </div>
      )}

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#f8fafc', textAlign: 'left', fontSize: 12, color: '#64748b' }}>
            <th style={cellStyle}>{'\uC544\uC774\uB514'}</th>
            <th style={cellStyle}>{'\uC774\uB984'}</th>
            <th style={cellStyle}>{'\uAD8C\uD55C'}</th>
            <th style={cellStyle}>{'\uC0DD\uC131\uC77C'}</th>
            <th style={{ ...cellStyle, textAlign: 'right' }}>{'\u00A0'}</th>
          </tr>
        </thead>
        <tbody>
          {loading && (<tr><td colSpan={5} style={{ ...cellStyle, textAlign: 'center', color: '#94a3b8' }}>{'\uBD88\uB7EC\uC624\uB294 \uC911...'}</td></tr>)}
          {!loading && members.length === 0 && (<tr><td colSpan={5} style={{ ...cellStyle, textAlign: 'center', color: '#94a3b8' }}>{'\uB4F1\uB85D\uB41C \uC9C1\uC6D0\uC774 \uC5C6\uC2B5\uB2C8\uB2E4'}</td></tr>)}
          {members.map(function(m) {
            var isOwner = m.memberRole === 'owner';
            return (
              <tr key={m.id}>
                <td style={cellStyle}>{m.userId}</td>
                <td style={cellStyle}>{m.name}</td>
                <td style={cellStyle}>
                  <span style={{ padding: '3px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, background: isOwner ? '#1B3A5C' : '#E6F1FB', color: isOwner ? '#fff' : '#1B3A5C' }}>
                    {isOwner ? 'owner' : 'member'}
                  </span>
                </td>
                <td style={{ ...cellStyle, color: '#94a3b8' }}>{(m.createdAt || '').slice(0, 10)}</td>
                <td style={{ ...cellStyle, textAlign: 'right' }}>
                  {!isOwner && (
                    <button onClick={function() { handleDelete(m); }} style={{ padding: '5px 10px', borderRadius: 5, background: '#fff', color: '#e24b4a', fontWeight: 600, fontSize: 11, border: '1px solid #e24b4a', cursor: 'pointer' }}>
                      {'\uC81C\uAC70'}
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
